import { useCurrentEnterprise } from '@mews-commander/legacy-entities/src/enterprise';
import { AmountPart, GeneralPricingMode, ProductData, ProductPricing } from '@mews-commander/data-access';
import { LocalizedCurrencyValue, lt, useLocalizePercentage } from '@mews/framework';
import { SpacedComma } from '@mews-commander/ui';
import { TextKey } from '@mews-commander/enums';

export const PricingCell = ({ pricing }: Pick<ProductData, 'pricing'>) => {
    const { pricing: pricingMode } = useCurrentEnterprise();
    const localizePercantage = useLocalizePercentage();

    if (pricing.discriminator === ProductPricing.Absolute) {
        return (
            <LocalizedCurrencyValue
                value={{
                    value: pricingMode === GeneralPricingMode.Gross ? pricing.value.grossValue : pricing.value.netValue,
                    currency: pricing.value.currency,
                }}
            />
        );
    }

    return pricing.value.productNames.length > 0 ? (
        lt('PercentageOfProductsAmountPartShort', {
            percentage: localizePercantage(pricing.value.multiplier, { maximumFractionDigits: 2 }),
            comaSeparatedListOfProducts: pricing.value.productNames.join(SpacedComma),
            pricePart: lt(valueTextKeyMap[pricing.value.target as AmountPart]),
        })
    ) : (
        <>{localizePercantage(pricing.value.multiplier, { maximumFractionDigits: 2 })}</>
    );
};

const valueTextKeyMap = {
    [AmountPart.GrossValue]: TextKey.CostPartGrossValue,
    [AmountPart.NetValue]: TextKey.CostPartNetValue,
    [AmountPart.TaxValue]: TextKey.CostPartTaxValue,
};
